import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './stores/authStore';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrdensServico from './pages/OrdensServico';
import Usuarios from './pages/Usuarios';
import Veiculos from './pages/Veiculos';
import CMV from './pages/CMV';
import Rastreamento from './pages/Rastreamento';
import Testes from './pages/Testes';
import RelatorioTempos from './pages/RelatorioTempos';
import Premiacao from './pages/Premiacao';
import OsKanban from './pages/OsKanban';
import Integracoes from './pages/Integracoes';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  const { isAuthenticated, user } = useAuthStore();

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
        
        <Routes>
          {/* Rota pública */}
          <Route 
            path="/login" 
            element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
            } 
          />
          
          {/* Rotas protegidas */}
          <Route path="/" element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="ordens-servico" element={<OrdensServico />} />
              <Route path="os-kanban" element={<OsKanban />} />
              <Route path="usuarios" element={<Usuarios />} />
              <Route path="veiculos" element={<Veiculos />} />
              <Route path="cmv" element={<CMV />} />
              <Route path="rastreamento" element={<Rastreamento />} />
              <Route path="relatorio-tempos" element={<RelatorioTempos />} />
              <Route path="premiacao" element={<Premiacao />} />
              <Route path="integracoes" element={<Integracoes />} />
              <Route path="testes" element={<Testes />} />
            </Route>
          </Route>
          
          {/* Rota 404 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

